import { useEffect, useState, useRef } from 'react';

export default function TeamScore({ score }) {
  const [displayedScore, setDisplayedScore] = useState(0);
  const prevScoreRef = useRef(0);

  useEffect(() => {
    if (prevScoreRef.current === score) return;

    const startValue = prevScoreRef.current;
    const endValue = score;
    const duration = 2000;
    const steps = 30;
    const stepTime = duration / steps;
    let currentStep = 0;

    const totalChange = endValue - startValue;
    const changePerStep = totalChange / steps;

    const interval = setInterval(() => {
      currentStep++;
      const newScore = startValue + (changePerStep * currentStep);
      
      if (currentStep === steps) {
        setDisplayedScore(endValue);
        prevScoreRef.current = endValue;
        clearInterval(interval);
      } else {
        setDisplayedScore(newScore);
      }
    }, stepTime);

    return () => clearInterval(interval);
  }, [score]);

  return (
    <span className="team-score animated">
      {Math.round(displayedScore).toLocaleString('en-US')}
    </span>
  );
}